import React from 'react';

const WheelTitleIcon = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M51.695 104.107C51.695 103.66 52.0541 103.309 52.5008 103.309C52.5168 103.309 52.5407 103.309 52.5646 103.309C52.5886 103.309 52.6205 103.309 52.6524 103.309C53.0911 103.301 53.4501 103.66 53.4501 104.099C53.4501 104.538 53.0991 104.897 52.6524 104.897C52.6284 104.897 52.6045 104.897 52.5726 104.897C52.5487 104.897 52.5247 104.897 52.5008 104.897C52.5008 104.897 52.5008 104.897 52.5008 104.905C52.0461 104.905 51.695 104.546 51.695 104.107ZM44.5231 104.29C44.0844 104.226 43.7892 103.82 43.853 103.381C43.9248 102.95 44.3237 102.647 44.7625 102.719C45.1933 102.783 45.4964 103.189 45.4326 103.628C45.3688 104.019 45.0257 104.306 44.6428 104.306C44.5949 104.306 44.563 104.298 44.5231 104.29ZM59.7126 103.604C59.6488 103.165 59.944 102.759 60.3827 102.695C60.8135 102.623 61.2284 102.918 61.2922 103.357C61.364 103.796 61.0608 104.203 60.63 104.274C60.5902 104.274 60.5423 104.282 60.5024 104.282C60.1195 104.282 59.7764 103.995 59.7126 103.604ZM36.721 102.471C36.2982 102.336 36.0668 101.889 36.2024 101.474C36.3381 101.051 36.7848 100.82 37.2076 100.956C37.6225 101.083 37.8538 101.53 37.7262 101.953C37.6145 102.296 37.3034 102.511 36.9683 102.511C36.8885 102.511 36.8087 102.495 36.721 102.471ZM67.4031 101.905C67.2674 101.49 67.4988 101.035 67.9216 100.908C68.3365 100.772 68.7832 101.003 68.9188 101.418C69.0545 101.841 68.8231 102.288 68.4083 102.424C68.3205 102.447 68.2407 102.463 68.1609 102.463C67.8339 102.463 67.5148 102.248 67.4031 101.905ZM29.3018 99.4718C28.9029 99.2723 28.7433 98.7937 28.9428 98.4028C29.1342 98.0119 29.6129 97.8444 30.0118 98.0438C30.4027 98.2432 30.5702 98.7139 30.3708 99.1128C30.2351 99.392 29.9479 99.5595 29.6528 99.5595C29.5411 99.5595 29.4214 99.5276 29.3018 99.4718ZM74.7425 99.049C74.5431 98.6501 74.7026 98.1714 75.1015 97.98C75.4924 97.7805 75.9711 97.9401 76.1705 98.331C76.37 98.7299 76.2024 99.2085 75.8115 99.408C75.6998 99.4638 75.5802 99.4877 75.4605 99.4877C75.1733 99.4877 74.8941 99.3282 74.7425 99.049ZM22.425 95.3713C22.066 95.124 21.9862 94.6214 22.2335 94.2624C22.4888 93.9034 22.9834 93.8156 23.3504 94.0709C23.7094 94.3262 23.7892 94.8208 23.5419 95.1798C23.3823 95.4032 23.135 95.5228 22.8877 95.5228C22.7282 95.5228 22.5766 95.475 22.425 95.3713ZM81.5554 95.1C81.3002 94.741 81.3879 94.2384 81.7469 93.9831C82.1059 93.7279 82.6005 93.8156 82.8558 94.1746C83.1111 94.5336 83.0313 95.0362 82.6723 95.2915C82.5287 95.3872 82.3692 95.4351 82.2096 95.4351C81.9543 95.4351 81.723 95.3154 81.5554 95.1ZM16.2663 90.2815C15.9471 89.9704 15.9392 89.4678 16.2423 89.1567C16.5534 88.8376 17.056 88.8296 17.3751 89.1327C17.6863 89.4359 17.7022 89.9385 17.3911 90.2576C17.2395 90.4171 17.0321 90.5049 16.8167 90.5049C16.6093 90.5049 16.4099 90.4331 16.2663 90.2815ZM87.7062 90.1619C87.3951 89.8428 87.4031 89.3401 87.7222 89.029C88.0413 88.7259 88.5439 88.7338 88.847 89.053C89.1582 89.3641 89.1502 89.8747 88.8311 90.1778C88.6795 90.3294 88.48 90.4012 88.2806 90.4012C88.0652 90.4012 87.8578 90.3214 87.7062 90.1619ZM10.9452 84.3142C10.6739 83.9632 10.7377 83.4606 11.0888 83.1974C11.4398 82.9261 11.9424 82.9899 12.2136 83.3409H12.2056C12.4769 83.692 12.413 84.1946 12.062 84.4578C11.9105 84.5695 11.7429 84.6254 11.5754 84.6254C11.3361 84.6254 11.0888 84.5216 10.9452 84.3142ZM93.0273 84.3461C92.6683 84.0829 92.6045 83.5803 92.8678 83.2293C93.139 82.8783 93.6416 82.8144 93.9926 83.0777C94.3357 83.341 94.4075 83.8435 94.1442 84.1946C93.9846 84.402 93.7453 84.5137 93.506 84.5137C93.3305 84.5137 93.1629 84.4578 93.0273 84.3461ZM6.57339 77.605C6.57339 77.605 6.57339 77.605 6.57339 77.613C6.358 77.2221 6.5016 76.7355 6.8925 76.528C7.27543 76.3126 7.76207 76.4562 7.97746 76.8471C8.18488 77.2301 8.04128 77.7167 7.65836 77.9321C7.53869 77.9959 7.40307 78.0278 7.27543 78.0278C6.99621 78.0278 6.72497 77.8762 6.57339 77.605ZM97.3991 77.7965C97.0162 77.5891 96.8725 77.1024 97.08 76.7195V76.7115C97.2874 76.3286 97.774 76.185 98.1649 76.3924C98.5479 76.6078 98.6915 77.0865 98.484 77.4774C98.3404 77.7406 98.0692 77.8922 97.782 77.8922C97.6464 77.8922 97.5187 77.8603 97.3991 77.7965ZM3.29458 70.3214C3.15098 69.9066 3.3584 69.4519 3.77324 69.3003C4.18808 69.1487 4.65078 69.3641 4.80236 69.7789C4.94596 70.1938 4.73056 70.6485 4.31572 70.8001C4.22797 70.832 4.14021 70.8479 4.04448 70.8479C3.70941 70.8479 3.40627 70.6485 3.29458 70.3214ZM100.734 70.6485C100.319 70.5049 100.096 70.0422 100.247 69.6273C100.399 69.2205 100.853 69.0051 101.268 69.1487C101.683 69.3003 101.898 69.755 101.747 70.1698C101.635 70.4969 101.324 70.6964 100.997 70.6964C100.901 70.6964 100.821 70.6804 100.734 70.6485ZM1.17252 62.607C1.08476 62.1762 1.36398 61.7534 1.80275 61.6736C2.23355 61.5938 2.64839 61.8731 2.73614 62.3039C2.81592 62.7346 2.5367 63.1575 2.1059 63.2372C2.05006 63.2452 2.0022 63.2532 1.95433 63.2532C1.57938 63.2532 1.24432 62.9899 1.17252 62.607ZM102.92 63.0777C102.489 62.9979 102.202 62.5751 102.289 62.1443C102.369 61.7135 102.784 61.4263 103.223 61.5061C103.654 61.5938 103.941 62.0087 103.853 62.4474C103.781 62.8224 103.446 63.0936 103.071 63.0936C103.023 63.0936 102.967 63.0857 102.92 63.0777ZM0.255086 54.6613C0.231153 54.2225 0.574192 53.8475 1.02094 53.8316C1.45971 53.8156 1.82669 54.1587 1.85062 54.5974H1.84265C1.8586 55.0362 1.52353 55.4112 1.07678 55.4271C1.06881 55.4271 1.06083 55.4271 1.05285 55.4271C0.614081 55.4271 0.271042 55.0921 0.255086 54.6613ZM103.925 55.2596C103.478 55.2436 103.135 54.8767 103.151 54.4379C103.167 53.9991 103.534 53.6481 103.981 53.6641C104.419 53.68 104.762 54.0549 104.747 54.4937C104.731 54.9245 104.38 55.2596 103.949 55.2596C103.933 55.2596 103.925 55.2596 103.925 55.2596ZM1.25229 47.5532C0.813523 47.4973 0.494418 47.1064 0.550262 46.6676C0.598128 46.2289 0.989032 45.9178 1.4278 45.9656C1.86657 46.0135 2.18568 46.4124 2.13782 46.8511C2.08995 47.258 1.73893 47.5532 1.34005 47.5532C1.30814 47.5532 1.2842 47.5532 1.25229 47.5532ZM102.832 46.6916C102.784 46.2528 103.095 45.8539 103.534 45.8061C103.973 45.7502 104.364 46.0693 104.419 46.5081C104.467 46.9389 104.156 47.3378 103.717 47.3856C103.685 47.3936 103.654 47.3936 103.622 47.3936C103.231 47.3936 102.888 47.0904 102.832 46.6916ZM2.6085 39.7909C2.18568 39.6792 1.93837 39.2404 2.05006 38.8096C2.16973 38.3868 2.6085 38.1395 3.03132 38.2512C3.45413 38.3709 3.70941 38.8096 3.58975 39.2325C3.49402 39.5915 3.17491 39.8228 2.82389 39.8228C2.76007 39.8228 2.6803 39.8148 2.6085 39.7909ZM101.34 39.0809C101.22 38.6501 101.468 38.2113 101.898 38.0996C102.321 37.98 102.76 38.2273 102.88 38.6501C102.999 39.0729 102.744 39.5117 102.321 39.6313C102.249 39.6553 102.178 39.6633 102.106 39.6633C101.763 39.6633 101.436 39.4319 101.34 39.0809ZM5.16933 32.3318C4.76247 32.1563 4.58696 31.6856 4.77045 31.2787C4.94595 30.8798 5.41664 30.6964 5.8235 30.8798C6.22238 31.0633 6.39789 31.534 6.22238 31.9329C6.08676 32.2281 5.79956 32.4036 5.49641 32.4036C5.37675 32.4036 5.27304 32.3796 5.16933 32.3318ZM98.7074 31.7893C98.5239 31.3904 98.6994 30.9118 99.1063 30.7363C99.5052 30.5528 99.9759 30.7283 100.159 31.1271C100.343 31.534 100.159 32.0047 99.7605 32.1882C99.6568 32.236 99.5451 32.26 99.4334 32.26C99.1302 32.26 98.843 32.0845 98.7074 31.7893ZM8.83107 25.3593C8.45612 25.12 8.35242 24.6254 8.59175 24.2504C8.83108 23.8834 9.32569 23.7718 9.70064 24.0191C10.0676 24.2584 10.1713 24.753 9.93199 25.12C9.78042 25.3593 9.52513 25.4869 9.26187 25.4869C9.11029 25.4869 8.95872 25.4471 8.83107 25.3593ZM94.9739 24.9923C94.7345 24.6254 94.8382 24.1307 95.2132 23.8914C95.5802 23.6441 96.0748 23.7478 96.3141 24.1228C96.5534 24.4897 96.4497 24.9844 96.0828 25.2237C95.9471 25.3114 95.7956 25.3513 95.644 25.3513C95.3807 25.3513 95.1254 25.2317 94.9739 24.9923ZM13.506 19.0171C13.1789 18.7219 13.155 18.2193 13.4422 17.8922C13.7373 17.5571 14.2399 17.5332 14.567 17.8204C14.8941 18.1156 14.926 18.6182 14.6388 18.9532C14.4793 19.1287 14.2559 19.2165 14.0405 19.2165C13.849 19.2165 13.6496 19.1527 13.506 19.0171ZM90.2591 18.8416C89.9639 18.5145 89.9878 18.0039 90.3229 17.7167C90.65 17.4215 91.1526 17.4455 91.4477 17.7726C91.7429 18.0996 91.711 18.6102 91.3839 18.9054C91.2323 19.041 91.0409 19.1048 90.8494 19.1048C90.634 19.1048 90.4186 19.0171 90.2591 18.8416ZM19.0903 13.4566C18.8111 13.1216 18.859 12.619 19.202 12.3318C19.5371 12.0526 20.0397 12.1004 20.3269 12.4435C20.6061 12.7785 20.5582 13.2811 20.2152 13.5683C20.0716 13.688 19.8881 13.7438 19.7126 13.7438C19.4813 13.7438 19.2499 13.6481 19.0903 13.4566ZM84.6508 13.4726C84.3077 13.1934 84.2599 12.6908 84.5471 12.3477C84.8183 12.0047 85.3289 11.9568 85.6639 12.2361C86.007 12.5153 86.0548 13.0179 85.7756 13.3609C85.6161 13.5524 85.3847 13.6481 85.1614 13.6481C84.9858 13.6481 84.8103 13.5923 84.6508 13.4726ZM25.4485 8.81364C25.2252 8.43071 25.3448 7.94407 25.7198 7.72069C26.1027 7.48934 26.5894 7.61698 26.8127 7.99193C27.0441 8.36688 26.9164 8.8615 26.5415 9.08488C26.4138 9.16465 26.2702 9.20454 26.1346 9.20454C25.8714 9.20454 25.6081 9.06095 25.4485 8.81364ZM78.3006 9.0051V9.01308C77.9256 8.78173 77.798 8.29509 78.0213 7.91216C78.2527 7.53721 78.7393 7.40957 79.1223 7.64092C79.4972 7.8643 79.6249 8.35093 79.4015 8.73386C79.2499 8.98116 78.9866 9.12477 78.7074 9.12477C78.5718 9.12477 78.4362 9.08487 78.3006 9.0051ZM32.445 5.19177C32.2774 4.78491 32.4769 4.31423 32.8837 4.15468C33.2906 3.98714 33.7613 4.17862 33.9208 4.58548C34.0883 5.00031 33.8969 5.46302 33.4821 5.63055C33.3863 5.67044 33.2826 5.68639 33.1869 5.68639C32.8598 5.68639 32.5646 5.5029 32.445 5.19177ZM71.352 5.56672C70.9451 5.40717 70.7457 4.93649 70.9053 4.52963C71.0728 4.12277 71.5355 3.92332 71.9424 4.09085C72.3572 4.25041 72.5487 4.72109 72.3891 5.12795C72.2615 5.43908 71.9663 5.63055 71.6472 5.63055C71.5515 5.63055 71.4477 5.60661 71.352 5.56672ZM39.9121 2.67882C39.8163 2.24802 40.0796 1.8252 40.5104 1.72149C40.9332 1.61778 41.364 1.88104 41.4677 2.31184C41.5714 2.74263 41.3002 3.17343 40.8773 3.27714C40.8135 3.28512 40.7497 3.29309 40.6859 3.29309C40.3269 3.29309 39.9998 3.04579 39.9121 2.67882ZM63.9567 3.23725C63.5259 3.13354 63.2627 2.71073 63.3584 2.27993C63.4621 1.84914 63.8849 1.5779 64.3157 1.68161C64.3157 1.68161 64.3157 1.68161 64.3237 1.68161C64.7465 1.78532 65.0178 2.20813 64.914 2.63892C64.8263 3.0059 64.4992 3.26118 64.1402 3.26118C64.0684 3.26118 64.0126 3.2532 63.9567 3.23725ZM47.6823 1.34655C47.6424 0.907776 47.9695 0.524842 48.4083 0.492931C48.847 0.461021 49.2379 0.788103 49.2698 1.22687C49.3018 1.66565 48.9747 2.04858 48.5359 2.08049C48.512 2.08049 48.496 2.08846 48.4721 2.08846C48.0493 2.08846 47.7142 1.76936 47.6823 1.34655ZM56.2902 2.07251C55.8514 2.04059 55.5243 1.65767 55.5562 1.21092C55.5882 0.772145 55.9711 0.445062 56.4098 0.476973C56.8486 0.508883 57.1757 0.891817 57.1438 1.33059C57.1119 1.7534 56.7609 2.07251 56.346 2.07251C56.3301 2.07251 56.3141 2.07251 56.2902 2.07251Z"
          fill="url(#paint0_linear_149_1552)"
        />
      </g>
    </g>
    <path
      d="M52.4924 98.3389C27.283 98.3389 6.77246 77.8284 6.77246 52.6189C6.77246 27.4095 27.283 6.89896 52.4924 6.89896C77.7019 6.89896 98.2124 27.4095 98.2124 52.6189C98.2124 77.8284 77.7019 98.3389 52.4924 98.3389ZM52.4924 7.69672C27.7218 7.69672 7.57023 27.8483 7.57023 52.6189C7.57023 77.3896 27.7218 97.5412 52.4924 97.5412C77.2631 97.5412 97.4147 77.3896 97.4147 52.6189C97.4147 27.8483 77.2631 7.69672 52.4924 7.69672Z"
      fill="url(#paint1_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M18.7309 87.0426C14.8618 83.2452 11.6866 78.8734 9.28536 74.039C5.95868 67.3457 4.27539 60.1419 4.27539 52.619H7.46646C7.46646 59.6473 9.03806 66.3724 12.1414 72.6189C14.3831 77.1343 17.3508 81.2189 20.9647 84.7689L18.7309 87.0426Z"
      fill="url(#paint2_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M52.4922 100.836V97.6449C56.5688 97.6449 60.6055 97.1024 64.4986 96.0254C71.1679 94.1826 77.4304 90.7442 82.6079 86.0932L84.7459 88.4626C79.2014 93.4486 72.5002 97.1263 65.3522 99.1048C61.1799 100.254 56.856 100.836 52.4922 100.836Z"
      fill="url(#paint3_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M100.71 52.6189H97.5186C97.5186 50.2336 97.3351 47.8483 96.9602 45.5188C96.7847 44.386 96.5533 43.2452 96.29 42.1363L99.3933 41.3943C99.6805 42.583 99.9199 43.8036 100.111 45.0162C100.51 47.5132 100.71 50.0741 100.71 52.6189Z"
      fill="url(#paint4_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M85.1453 21.6098C83.0951 19.4478 80.8215 17.4853 78.3883 15.7781C72.9315 11.9329 66.8446 9.40394 60.2949 8.26313L60.8454 5.11993C67.8657 6.34849 74.3835 9.05292 80.2311 13.1694C82.8318 15.0043 85.265 17.1024 87.4589 19.4159L85.1453 21.6098Z"
      fill="url(#paint5_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M52.4932 95.499C28.8474 95.499 9.61328 76.2648 9.61328 52.6191C9.61328 28.9733 28.8474 9.73911 52.4932 9.73911C76.139 9.73911 95.3731 28.9733 95.3731 52.6191C95.3731 76.2648 76.139 95.499 52.4932 95.499ZM52.4932 9.93855C28.9591 9.93855 9.81272 29.0849 9.81272 52.6191C9.81272 76.1532 28.9591 95.2995 52.4932 95.2995C76.0273 95.2995 95.1737 76.1532 95.1737 52.6191C95.1737 29.0849 76.0273 9.93855 52.4932 9.93855Z"
      fill="url(#paint6_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M52.4931 85.4872V85.2877C70.5067 85.2877 85.1617 70.6328 85.1617 52.6192C85.1617 34.6056 70.5067 19.9507 52.4931 19.9507C34.4796 19.9507 19.8166 34.6056 19.8166 52.6192H19.6172C19.6172 34.494 34.3599 19.7512 52.4931 19.7512C70.6184 19.7512 85.3611 34.494 85.3611 52.6192C85.3611 70.7444 70.6184 85.4872 52.4931 85.4872Z"
      fill="url(#paint7_linear_149_1552)"
      className="svg-wheel-2"
    />
    <path
      d="M52.4929 83.5964C35.4127 83.5964 21.5156 69.6993 21.5156 52.6191H23.1112C23.1112 68.8218 36.2903 82.0009 52.4929 82.0009V83.5964Z"
      fill="url(#paint8_linear_149_1552)"
      className="svg-wheel-1"
    />
    <g opacity="0.04">
      <path
        opacity="0.04"
        d="M52.4934 52.6192H92.0785C92.0785 74.3344 74.2086 92.2043 52.4934 92.2043C30.7782 92.2043 12.9082 74.3344 12.9082 52.6192C12.9082 41.3467 17.7267 30.5928 26.1352 23.0858L52.4934 52.6192Z"
        fill="url(#paint9_linear_149_1552)"
        className="svg-wheel-1"
      />
    </g>
    <g opacity="0.08">
      <path
        opacity="0.08"
        d="M52.4928 92.6031C30.4426 92.6031 12.5088 74.6693 12.5088 52.6191C12.5088 30.5688 30.4426 12.635 52.4928 12.635C74.5431 12.635 92.4769 30.5688 92.4769 52.6191C92.4769 74.6693 74.5431 92.6031 52.4928 92.6031ZM52.4928 13.4328C30.8893 13.4328 13.3066 31.0156 13.3066 52.6191C13.3066 74.2226 30.8893 91.8053 52.4928 91.8053C74.0963 91.8053 91.6791 74.2226 91.6791 52.6191C91.6791 31.0156 74.0963 13.4328 52.4928 13.4328Z"
        fill="url(#paint10_linear_149_1552)"
        className="svg-wheel-1"
      />
    </g>
    <path
      d="M52.5969 9.83505H52.3975V16.2252H52.5969V9.83505Z"
      fill="url(#paint11_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M52.5969 89.0054H52.3975V95.3955H52.5969V89.0054Z"
      fill="url(#paint12_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M49.2225 16.3767L48.6641 10.0105L48.8635 9.99457L49.4219 16.3607L49.2225 16.3767Z"
      fill="url(#paint13_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M56.1229 95.244L55.5645 88.8779L55.7639 88.8619L56.3223 95.2281L56.1229 95.244Z"
      fill="url(#paint14_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M46.0788 16.7994L44.9619 10.505L45.1614 10.4731L46.2703 16.7675L46.0788 16.7994Z"
      fill="url(#paint15_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M59.8247 94.7652L58.7158 88.4708L58.9073 88.4389L60.0162 94.7333L59.8247 94.7652Z"
      fill="url(#paint16_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M42.9756 17.4935L41.3242 11.3188L41.5157 11.2709L43.175 17.4456L42.9756 17.4935Z"
      fill="url(#paint17_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M63.4699 93.9674L61.8105 87.7927L62.01 87.7449L63.6614 93.9196L63.4699 93.9674Z"
      fill="url(#paint18_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M39.9525 18.4589L37.7666 12.4517L37.9581 12.3799L40.1439 18.3871L39.9525 18.4589Z"
      fill="url(#paint19_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M67.0286 92.8505L64.8428 86.8513L65.0342 86.7795L67.2201 92.7867L67.0286 92.8505Z"
      fill="url(#paint20_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M34.505 13.8047L34.3242 13.889L37.0253 19.6803L37.2061 19.596L34.505 13.8047Z"
      fill="url(#paint21_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M67.9747 85.5506L67.7939 85.6349L70.495 91.4263L70.6758 91.342L67.9747 85.5506Z"
      fill="url(#paint22_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M31.1854 15.5105L31.0127 15.6103L34.2077 21.1441L34.3805 21.0444L31.1854 15.5105Z"
      fill="url(#paint23_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M70.7694 84.0805L70.5967 84.1802L73.7917 89.7141L73.9644 89.6143L70.7694 84.0805Z"
      fill="url(#paint24_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M28.0442 17.5271L27.8809 17.6415L31.5462 22.8763L31.7096 22.7619L28.0442 17.5271Z"
      fill="url(#paint25_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M76.9529 87.7209L73.2832 82.4876L73.4428 82.3679L77.1125 87.6092L76.9529 87.7209Z"
      fill="url(#paint26_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M29.0226 24.8091L24.9141 19.9108L25.0736 19.7832L29.1821 24.6815L29.0226 24.8091Z"
      fill="url(#paint27_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M79.9122 85.4554L75.8037 80.5571L75.9633 80.4295L80.0718 85.3278L79.9122 85.4554Z"
      fill="url(#paint28_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M16.2343 49.5477L9.86816 48.9893L9.88412 48.7898L16.2503 49.3483L16.2343 49.5477Z"
      fill="url(#paint29_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M95.1015 56.4483L88.7354 55.8898L88.7513 55.6904L95.1175 56.2488L95.1015 56.4483Z"
      fill="url(#paint30_linear_149_1552)"
        className="svg-wheel-1"
    />
    <path
      d="M16.0991 52.5155H9.70898V52.715H16.0991V52.5155Z"
      fill="url(#paint31_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M95.269 52.5156H88.8789V52.715H95.269V52.5156Z"
      fill="url(#paint32_linear_149_1552)"
      className="svg-wheel-1"
    />
    <path
      d="M52.4931 87.4735C33.2749 87.4735 17.6387 71.8373 17.6387 52.6191C17.6387 33.4009 33.2749 17.7647 52.4931 17.7647V18.1636C33.4903 18.1636 18.0376 33.6243 18.0376 52.6191C18.0376 71.6219 33.4983 87.0746 52.4931 87.0746C71.4959 87.0746 86.9486 71.6139 86.9486 52.6191H87.3475C87.3475 71.8373 71.7113 87.4735 52.4931 87.4735Z"
      fill="url(#paint33_linear_149_1552)"
      className="svg-wheel-1"
    />
    <defs>
      <linearGradient
        id="paint0_linear_149_1552"
        x1="98.4626"
        y1="52.8722"
        x2="3.06408"
        y2="52.7637"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_149_1552"
        x1="92.7131"
        y1="52.7787"
        x2="9.23159"
        y2="52.6838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_149_1552"
        x1="19.9609"
        y1="69.8909"
        x2="4.72421"
        y2="69.8825"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_149_1552"
        x1="82.8061"
        y1="93.4903"
        x2="53.3597"
        y2="93.4171"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_149_1552"
        x1="100.444"
        y1="47.0262"
        x2="96.4089"
        y2="47.0244"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_149_1552"
        x1="85.8252"
        y1="13.3937"
        x2="61.0255"
        y2="13.3472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_149_1552"
        x1="90.2154"
        y1="52.7689"
        x2="11.9197"
        y2="52.6799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_149_1552"
        x1="81.4072"
        y1="52.7341"
        x2="21.3853"
        y2="52.6658"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_149_1552"
        x1="50.6299"
        y1="68.1619"
        x2="22.3487"
        y2="68.1298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_149_1552"
        x1="87.3171"
        y1="57.7659"
        x2="15.0374"
        y2="57.6718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_149_1552"
        x1="87.6675"
        y1="52.7588"
        x2="14.6594"
        y2="52.6758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_149_1552"
        x1="52.5849"
        y1="13.0413"
        x2="52.4028"
        y2="13.0413"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_149_1552"
        x1="52.5849"
        y1="92.2116"
        x2="52.4028"
        y2="92.2116"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_149_1552"
        x1="49.3764"
        y1="13.1968"
        x2="48.6844"
        y2="13.1967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_149_1552"
        x1="56.2767"
        y1="92.0641"
        x2="55.5848"
        y2="92.064"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_149_1552"
        x1="46.1916"
        y1="13.6473"
        x2="44.9971"
        y2="13.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_149_1552"
        x1="59.938"
        y1="91.6131"
        x2="58.7508"
        y2="91.6128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_149_1552"
        x1="43.0637"
        y1="14.393"
        x2="41.374"
        y2="14.3925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_149_1552"
        x1="63.55"
        y1="90.867"
        x2="61.8603"
        y2="90.8665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_149_1552"
        x1="40.001"
        y1="15.43"
        x2="37.8305"
        y2="15.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_149_1552"
        x1="67.0771"
        y1="89.8256"
        x2="64.9067"
        y2="89.8246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_149_1552"
        x1="35.8494"
        y1="16.7155"
        x2="35.6843"
        y2="16.7925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_149_1552"
        x1="69.3191"
        y1="88.4615"
        x2="69.1541"
        y2="88.5384"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_149_1552"
        x1="32.7781"
        y1="18.2931"
        x2="32.6204"
        y2="18.3842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_149_1552"
        x1="72.3621"
        y1="86.8631"
        x2="72.2044"
        y2="86.9541"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_149_1552"
        x1="29.8735"
        y1="20.1605"
        x2="29.7243"
        y2="20.265"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_149_1552"
        x1="76.8822"
        y1="85.0538"
        x2="73.3862"
        y2="85.0509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_149_1552"
        x1="28.9254"
        y1="22.3049"
        x2="25.0288"
        y2="22.3012"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_149_1552"
        x1="79.8151"
        y1="82.9513"
        x2="75.9185"
        y2="82.9475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_149_1552"
        x1="15.8665"
        y1="49.1701"
        x2="10.0403"
        y2="49.1143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_149_1552"
        x1="94.7336"
        y1="56.0706"
        x2="88.9075"
        y2="56.0149"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_149_1552"
        x1="15.7148"
        y1="52.6156"
        x2="9.88855"
        y2="52.4034"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_149_1552"
        x1="94.8847"
        y1="52.6157"
        x2="89.0585"
        y2="52.4035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_149_1552"
        x1="83.1551"
        y1="52.7409"
        x2="19.5134"
        y2="52.6686"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8FDFC" />
        <stop offset="0.447917" stopColor="#BAC1FF" />
        <stop offset="0.989583" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default WheelTitleIcon;
